class AnnouncementHeightCalc {
    init() {
        const element = document.querySelector('.announcement-bar');

        const updateHeight = () => {
            const ah = element ? element.offsetHeight : 0;

            document.documentElement.style.setProperty('--ah', `${ah}px`);
        };

        updateHeight();

        if (element) {
            this.observer = new ResizeObserver(updateHeight);
            this.observer.observe(element);
        }
    }
}

export default new AnnouncementHeightCalc();
